import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* addSignatureListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_SIGNATURE, payload);
    if (response.status == 200) {
      yield put(ACTION.addSignature_Success(response.data));
    } else {
      yield put(ACTION.addSignature_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addSignature_Fail(response.data.error));
  }
}

function* getSignatureListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SIGNATURE, payload);
    if (response.status == 200) {
      yield put(ACTION.getSignature_Success(response.data));
    } else {
      yield put(ACTION.getSignature_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getSignature_Fail(response.data.error));
  }
}

function* getSignatureByIdListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SIGNATURE_BY_ID, payload);
    if (response.status == 200) {
      yield put(ACTION.getSignatureById_Success(response.data));
    } else {
      yield put(ACTION.getSignatureById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getSignatureById_Fail(response.data.error));
  }
}

function* updateSignatureListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_SIGNATURE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateSignature_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateSignature_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateSignature_Fail(response.data.error));
  }
}

function* deleteSignatureListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_SIGNATURE, payload);
    if (response.status == 200) {
      yield put(ACTION.deleteSignature_Success(response.data));
    } else {
      yield put(ACTION.deleteSignature_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteSignature_Fail(response.data.error));
  }
}

function* getMessageListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_MESSAGE_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getMessageList_Success(response.data));
    } else {
      yield put(ACTION.getMessageList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getMessageList_Fail(response.data.error));
  }
}

function* getMessageByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_MESSAGE_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getMessageById_Success(response.data));
    } else {
      yield put(ACTION.getMessageById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getMessageById_Fail(response.data.error));
  }
}

function* getSubscriberListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SUBSCRIBER_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getSubscriberList_Success(response.data));
    } else {
      yield put(ACTION.getSubscriberList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getSubscriberList_Fail(response.data.error));
  }
}

function* getSubscriberByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SUBSCRIBER_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getSubscriberById_Success(response.data));
    } else {
      yield put(ACTION.getSubscriberById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getSubscriberById_Fail(response.data.error));
  }
}

function* getFacebookListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FACEBOOK_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getFacebookList_Success(response.data));
    } else {
      yield put(ACTION.getFacebookList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getFacebookList_Fail(response.data.error));
  }
}

function* getFacebookByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FACEBOOK_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getFacebookById_Success(response.data));
    } else {
      yield put(ACTION.getFacebookById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getFacebookById_Fail(response.data.error));
  }
}

function* getInstagramListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_INSTAGRAM_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getInstagramList_Success(response.data));
    } else {
      yield put(ACTION.getInstagramById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getInstagramById_Fail(response.data.error));
  }
}

function* getInstagramByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_INSTAGRAM_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getInstagramById_Success(response.data));
    } else {
      yield put(ACTION.getInstagramById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getInstagramById_Fail(response.data.error));
  }
}

function* getTwitterListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_TWITTER_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getTwitterList_Success(response.data));
    } else {
      yield put(ACTION.getTwitterList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getTwitterList_Fail(response.data.error));
  }
}

function* getTwitterByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_TWITTER_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getTwitterById_Success(response.data));
    } else {
      yield put(ACTION.getTwitterById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getTwitterById_Fail(response.data.error));
  }
}

function* getYoutubeListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_YOUTUBE_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getYoutubeList_Success(response.data));
    } else {
      yield put(ACTION.getYoutubeList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getYoutubeList_Fail(response.data.error));
  }
}

function* getYoutubeByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_YOUTUBE_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getYoutubeById_Success(response.data));
    } else {
      yield put(ACTION.getYoutubeById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getYoutubeById_Fail(response.data.error));
  }
}

function* getTiktokListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_TIKTOK_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getTiktokList_Success(response.data));
    } else {
      yield put(ACTION.getTiktokList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getTiktokList_Fail(response.data.error));
  }
}

function* getTiktokByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_TIKTOK_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getTiktokById_Success(response.data));
    } else {
      yield put(ACTION.getTiktokById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getTiktokById_Fail(response.data.error));
  }
}

function* getFormListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FORM_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getFormList_Success(response.data));
    } else {
      yield put(ACTION.getFormList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getFormList_Fail(response.data.error));
  }
}

function* getFormByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FORM_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getFormById_Success(response.data));
    } else {
      yield put(ACTION.getFormById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getFormById_Fail(response.data.error));
  }
}

function* getFinanceListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FINANCE_LIST, payload);
    if (response.data.data) {
      yield put(ACTION.getFinanceList_Success(response.data));
    } else {
      yield put(ACTION.getFinanceList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getFinanceList_Fail(response.data.error));
  }
}

function* getFinanceByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FINANCE_BY_ID, payload);
    if (response.data.data) {
      yield put(ACTION.getFinanceById_Success(response.data));
    } else {
      yield put(ACTION.getFinanceById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getFinanceById_Fail(response.data.error));
  }
}

function* getDetailSettingSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_DETAIL_SETTINGS, payload);
    if (response.data.data) {
      yield put(ACTION.getDetailSettings_Success(response.data));
    } else {
      yield put(ACTION.getDetailSettings_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getDetailSettings_Fail(response.data.error));
  }
}

function* updateDetailSettingSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_DETAIL_SETTING, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateDetailSettings_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateDetailSettings_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateDetailSettings_Fail(response.data.error));
  }
}

function* postFinancialSaga({ payload, userId, callBack }) {
  try {
    const response = yield call(API.POST_FINANCIAL, { payload, userId });
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.postFinancial_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.postFinancial_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.postFinancial_Fail(error));
  }
}

function* postSubadminSaga({ payload, callBack }) {
  try {
    const response = yield call(API.POST_SUBADMIN, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.postSubadmin_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.postSubadmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.postSubadmin_Fail(error));
  }
}

function* getSubadminListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SUBADMIN_LIST, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getSubadminList_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.getSubadminList_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getSubadminList_Fail(error));
  }
}

function* getSubadminByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SUBADMIN_BY_ID, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getSubadminById_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.getSubadminById_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getSubadminById_Fail(error));
  }
}

function* updateSubadminSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_SUBADMIN, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateSubadmin_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateSubadmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.updateSubadmin_Fail(error));
  }
}

function* deleteSubadminSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_SUBADMIN, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteSubadmin_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.deleteSubadmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.deleteSubadmin_Fail(error));
  }
}

function* resetSubadminPassSaga({ payload, callBack }) {
  try {
    const response = yield call(API.RESET_SUBADMIN_PASS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.resetSubadminPass_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.resetSubadminPass_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.resetSubadminPass_Fail(error));
  }
}

function* dropdownSubadminSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DROPDOWN_SUBADMIN, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.dropdownSubadmin_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.dropdownSubadmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.dropdownSubadmin_Fail(error));
  }
}

// ===================== role ============== //

function* postRoleSaga({ payload, callBack }) {
  try {
    const response = yield call(API.POST_ROLE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.postRole_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.postRole_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.postRole_Fail(error));
  }
}

function* getRoleListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_ROLE_LIST, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getRoleList_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.getRoleList_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getRoleList_Fail(error));
  }
}

function* getRoleByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_ROLE_BY_ID, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getRoleById_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.getRoleById_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getRoleById_Fail(error));
  }
}

function* updateRoleSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_ROLE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateRole_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateRole_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.updateRole_Fail(error));
  }
}

function* deleteRoleSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_ROLE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteRole_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.deleteRole_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.deleteRole_Fail(error));
  }
}

// ===================== role end =============== //

function* adminDetailSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADMIN_DETAIL, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.adminDetail_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.adminDetail_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.adminDetail_Fail(error));
  }
}

function* rowSortingSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ROW_SORTING, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.rowSorting_Success(response.data));
    } else {
      yield put(ACTION.rowSorting_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.rowSorting_Fail(error));
  }
}

function* postConfigureSaga({ payload, callBack }) {
  try {
    const response = yield call(API.POST_CONFIGURE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.postConfigure_Success(response.data));
    } else {
      yield put(ACTION.postConfigure_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.postConfigure_Fail(error));
  }
}

function* getConfigureSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_CONFIGURE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getConfigure_Success(response.data));
    } else {
      yield put(ACTION.getConfigure_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getConfigure_Fail(error));
  }
}

function* getFieldDataSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_FIELD_DATA, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getFieldData_Success(response.data));
    } else {
      yield put(ACTION.getFieldData_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getFieldData_Fail(error));
  }
}

function* sendEmailSubscriberSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SEND_EMAIL_SUBSCRIBER, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.sendEmailSubscriber_Success(response.data));
    } else {
      yield put(ACTION.sendEmailSubscriber_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.sendEmailSubscriber_Fail(error));
  }
}

function* sendSmsSubscriberSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SEND_SMS_SUBSCRIBER, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.sendSmsSubscriber_Success(response.data));
    } else {
      yield put(ACTION.sendSmsSubscriber_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.sendSmsSubscriber_Fail(error));
  }
}

function* healthInsuranceSaga({ payload, callBack }) {
  try {
    const response = yield call(API.HEALTH_INSURANCE_LIST, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.healthInsuranceList_Success(response.data));
    } else {
      yield put(ACTION.healthInsuranceList_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.healthInsuranceList_Fail(error));
  }
}

function* getHealthInsuranceSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_HEALTH_INSURANCE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getHealthInsurance_Success(response.data));
    } else {
      yield put(ACTION.getHealthInsurance_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.getHealthInsurance_Fail(error));
  }
}

function* convertToIrsSaga({ payload, callBack }) {
  try {
    const response = yield call(API.CONVERT_TO_IRS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.convertToIrs_Success(response.data));
    } else {
      yield put(ACTION.convertToIrs_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.convertToIrs_Fail(error));
  }
}

function* SignatureSaga() {
  yield takeEvery(CONST.ADD_SIGNATURE, addSignatureListSaga);
  yield takeEvery(CONST.GET_SIGNATURE, getSignatureListSaga);
  yield takeEvery(CONST.GET_SIGNATURE_BY_ID, getSignatureByIdListSaga);
  yield takeEvery(CONST.UPDATE_SIGNATURE, updateSignatureListSaga);
  yield takeEvery(CONST.DELETE_SIGNATURE, deleteSignatureListSaga);
  yield takeEvery(CONST.GET_MESSAGE_LIST, getMessageListSaga);
  yield takeEvery(CONST.GET_MESSAGE_BY_ID, getMessageByIdSaga);
  yield takeEvery(CONST.GET_SUBSCRIBER_LIST, getSubscriberListSaga);
  yield takeEvery(CONST.GET_SUBSCRIBER_BY_ID, getSubscriberByIdSaga);
  yield takeEvery(CONST.GET_FACEBOOK_LIST, getFacebookListSaga);
  yield takeEvery(CONST.GET_FACEBOOK_BY_ID, getFacebookByIdSaga);
  yield takeEvery(CONST.GET_INSTAGRAM_LIST, getInstagramListSaga);
  yield takeEvery(CONST.GET_INSTAGRAM_BY_ID, getInstagramByIdSaga);
  yield takeEvery(CONST.GET_TWITTER_LIST, getTwitterListSaga);
  yield takeEvery(CONST.GET_TWITTER_BY_ID, getTwitterByIdSaga);
  yield takeEvery(CONST.GET_YOUTUBE_LIST, getYoutubeListSaga);
  yield takeEvery(CONST.GET_YOUTUBE_BY_ID, getYoutubeByIdSaga);
  yield takeEvery(CONST.GET_TIKTOK_LIST, getTiktokListSaga);
  yield takeEvery(CONST.GET_TIKTOK_BY_ID, getTiktokByIdSaga);
  yield takeEvery(CONST.GET_DETAIL_SETTINGS, getDetailSettingSaga);
  yield takeEvery(CONST.UPDATE_DETAIL_SETTING, updateDetailSettingSaga);
  yield takeEvery(CONST.GET_FORM_LIST, getFormListSaga);
  yield takeEvery(CONST.GET_FORM_BY_ID, getFormByIdSaga);
  yield takeEvery(CONST.GET_FINANCE_LIST, getFinanceListSaga);
  yield takeEvery(CONST.GET_FINANCE_BY_ID, getFinanceByIdSaga);
  yield takeEvery(CONST.POST_FINANCIAL, postFinancialSaga);

  yield takeEvery(CONST.POST_SUBADMIN, postSubadminSaga);
  yield takeEvery(CONST.GET_SUBADMIN_BY_ID, getSubadminByIdSaga);
  yield takeEvery(CONST.GET_SUBADMIN_LIST, getSubadminListSaga);
  yield takeEvery(CONST.UPDATE_SUBADMIN, updateSubadminSaga);
  yield takeEvery(CONST.DELETE_SUBADMIN, deleteSubadminSaga);
  yield takeEvery(CONST.RESET_SUBADMIN_PASS, resetSubadminPassSaga);
  yield takeEvery(CONST.DROPDOWN_SUBADMIN, dropdownSubadminSaga);

  yield takeEvery(CONST.POST_ROLE, postRoleSaga);
  yield takeEvery(CONST.GET_ROLE_BY_ID, getRoleByIdSaga);
  yield takeEvery(CONST.GET_ROLE_LIST, getRoleListSaga);
  yield takeEvery(CONST.UPDATE_ROLE, updateRoleSaga);
  yield takeEvery(CONST.DELETE_ROLE, deleteRoleSaga);

  yield takeEvery(CONST.ADMIN_DETAIL, adminDetailSaga);
  yield takeEvery(CONST.ROW_SORTING, rowSortingSaga);
  yield takeEvery(CONST.POST_CONFIGURE, postConfigureSaga);
  yield takeEvery(CONST.GET_CONFIGURE, getConfigureSaga);
  yield takeEvery(CONST.GET_FIELD_DATA, getFieldDataSaga);

  yield takeEvery(CONST.SEND_EMAIL_SUBSCRIBER, sendEmailSubscriberSaga);
  yield takeEvery(CONST.SEND_SMS_SUBSCRIBER, sendSmsSubscriberSaga);
  yield takeEvery(CONST.HEALTH_INSURANCE_LIST, healthInsuranceSaga);
  yield takeEvery(CONST.GET_HEALTH_INSURANCE, getHealthInsuranceSaga);
  yield takeEvery(CONST.CONVERT_TO_IRS, convertToIrsSaga);
}

export default SignatureSaga;
